<template>
  <div>
    <v-card outlined class="pa-4 pa-sm-8" max-width="650">
      <v-alert color="primary" text class="pl-8 mb-8">
        <ressource code="informations_infos_societe" />
      </v-alert>
      <v-row>
        <v-col cols="12" md="2">
          <v-icon x-large>mdi-domain</v-icon>
        </v-col>
        <v-col cols="12" md="10">
          <CarteIdentificationLigne code="nom" :value="societe.nom" />
          <CarteIdentificationLigne code="formeJuridique" :value="societe.formeJuridique" />
          <CarteIdentificationLigne code="neq" :value="societe.neq" />
          <slot name="infos-societes" />
        </v-col>
      </v-row>
      <v-divider class="my-6"></v-divider>
      <v-row>
        <v-col cols="12" md="2">
          <v-icon x-large>mdi-map-marker</v-icon>
        </v-col>
        <v-col cols="12" md="10">
          <CarteIdentificationLigne code="adresse" :value="societe.adresse" />
          <CarteIdentificationLigne code="adresse_2" :value="societe.adresseLigne2" />
          <CarteIdentificationLigne code="ville" :value="societe.ville" />
          <CarteIdentificationLigne code="code_postal" :value="societe.codePostal" />
          <CarteIdentificationLigne code="province" :value="societe.province" />
          <CarteIdentificationLigne code="pays" :value="societe.pays" />
          <CarteIdentificationLigne code="telephone" :value="societe.telephone" />
          <CarteIdentificationLigne code="fax" :value="societe.fax" />
          <slot name="infos-adresse" />
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import CarteIdentificationLigne from "./CarteIdentificationLigne.vue"
export default {
  components: { CarteIdentificationLigne },
  props: {
    societe: Object
  }
}
</script>